import React, { useState } from 'react';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, Button, ButtonGroup, IconButton, Tooltip } from '@mui/material';
import { Input, Space, Spin } from 'antd';
import ButtonAnt from 'antd/lib/button';
import Table, { ColumnsType } from 'antd/es/table';
import { Crypter } from '../../../../Functions/Security/Crypter';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from "sweetalert2"
import Data from '../../../../Data/Data.json'
import DataTypeTable from '../../../../Types/DataTypeTable';
import Utilisateur from '../../../../Models/Utilisateur';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import ConfirmeLitige from './ConfirmeLitige';
import OperationCaisse from '../../../../Models/OperationCaisse';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import { Person2 } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { apiEndpoints } from '../../../../config';
import { formatCurrency, PrintRecuCaisseDirect } from '../../../../utilitaires/globalFunction';
import { lib } from 'crypto-js';

interface SelectData {
  value: string,
  label: string,
}


let searchTypAdr: Params = { CodeAgence: '', Table: "TYPADR", Colonne1: "CODTYPE", Colonne2: "LIBELL1", Colagence: '001', Choix: 22 }
let searchAgence: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGroup: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }


function Tab2(props: { form?: any }) {
  const [garantie, SetGarantie] = React.useState<SelectData[]>([]);
  const [Donnee, setDonnee] = React.useState<any[]>([]);
  const [pageIsLoad, setPageIsLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [valeur, setvaleur] = useState<string>();
  const [montant, setMontant] = useState<number>(0);
  const [pourcentage, setPourcentage] = useState<number>(0);
  const [valeursDeGarantie, setValeursDeGarantie] = useState<number>(0)
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const navigate = useNavigate()


  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const columns: ColumnsType<any> = [
    // {
    //   title: 'Numéro ordre',
    //   dataIndex: 'NLINE',
    // },
    {
      title: 'Numero ordre',
      key: 'NLINE',
      render: (_, record: any) => (
        <>
          <Button size='small' color={(record.CDETAT == '12') ? "primary" : (record.CDETAT == '16') ? "success" : (record.CDETAT == '06') ? "error" : "inherit"} variant='contained' style={{ boxShadow: 'none' }}>{record.NLINE}</Button>
          <br />
          <p style={{ textAlign: "center" }}>{record.CDETAT == "13" ? "En attente de validation" : record.CDETAT == "12" ? "En attente de confirmation" : record.CDETAT == "16" ? "Opération confirmé" : record.CDETAT == "06" ? "Opération regeté" : ""}</p>

        </>
      ),
    },
    {
      title: 'Compte',
      dataIndex: 'NODUCP',
    },
    {
      title: 'Libellé',
      dataIndex: 'LIBELL',
    },
    {
      title: 'Date',
      dataIndex: 'DATECR',
    },
    {
      title: 'Remettant',
      dataIndex: 'REMETT',
    },
    {
      title: 'CNI',
      dataIndex: 'cniremet',
    },
    {
      title: 'Montant',
      dataIndex: 'MONTAN',
    },
    {
      title: 'Libellé',
      dataIndex: 'LIBELL',
    },
    {
      title: 'Motif',
      dataIndex: 'LIBOPE',
    },
    {
      title: <Tooltip title='Solde après opération'><p>Solde après opération</p></Tooltip>,
      dataIndex: 'soldeApreOpe',
    },
    {
      title: 'Validé par',
      dataIndex: 'UTIVAL',
    },
    {
      title: 'Action',
      key: 'view',
      render: (_, record: any) => (
        <Box>
          <ButtonGroup disabled={!(record.CDETAT == '12')} orientation='horizontal' variant='contained' size='small' style={{ boxShadow: "none" }}>
            <ConfirmeLitige onFinish={() => { ConfirmLitige(Donnee.find((e) => e.key == record.key)) }} data={Donnee.find((e) => e.key == record.key)} form={props.form} title={"Confirmer cette opération"} />
            <Tooltip title='Rejeter cette opération'>
              <Button onClick={() => { regetLitige(record) }} style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px" }} color='error' >R</Button>
            </Tooltip>
          </ButtonGroup>
          <Tooltip title='Tranférer cette opération pour validation'>
            <IconButton onClick={() => { transfert(record) }} disabled={(record.CDETAT == '12')} color='primary'><Person2 /></IconButton>
          </Tooltip>
        </Box>
      ),
    },

  ];

  if (pageIsLoad) {
    setPageIsLoad(false)
    LoadLitige()
  }

  const handleDownloadRecuDirect = async (Nodece: string, NumSeq: string, UtiSai: string, SensOpe: string, Devise: string, LibDevise: string, LibInfos: string, NumCpt: string, montantOpe: number, CDDEVS: string, format: string = "pdf") => {
    try {
      // alert(Nodece+"-"+NumSeq+"-"+UtiSai+"-"+SensOpe+"-"+Devise+"-"+LibDevise+"-"+LibInfos+"-"+NumCpt+"-"+montantOpe+"-"+CDDEVS+"-"+format)
      //setLoading(true);
      // let Nodece = form.getFieldValue("NODECE");
      // let NumSeq = form.getFieldValue("NUMSEQ");
      // let UtiSai = form.getFieldValue("UTISAI");
      let CodAgce = user?.codage || "";
      let Libelle = user.agence;
      let NomUser = user?.nomuti || "";
      // let SensOpe = form.getFieldValue("lib_CODOPE") || "";
      // let Devise = form.getFieldValue("lib_CDDEVS") || "XAF";
      // let LibInfos = form.getFieldValue("CODOPE1") || "";
      // let NumCpt=form.getFieldValue("NUMCPT") || ""
      let Montan = formatCurrency(montantOpe, Devise)//formatCurrency (form.getFieldValue("montantOpe") ?? "0",form.getFieldValue("CDDEVS") || "XAF")


      //alert(Montan)


      if (LibInfos == "950" || LibInfos == "050") {
        SensOpe = "VERSEMENT ESPECES"
        LibInfos = "Nous portons au crédit du compte: " + NumCpt + " la somme de :" + Montan + " " + LibDevise;
      }
      if (LibInfos == "951" || LibInfos == "051") {
        SensOpe = "RETRAIT ESPECES"
        LibInfos = "Nous portons au débit du compte: " + NumCpt + " la somme de :" + Montan + " " + LibDevise;
      }





      // const op: OperationCaisse = form.getFieldsValue();
      // console.log(op)
      // op.DISPON = ReformatNumber(form.getFieldValue("DISPON") ?? "0");
      // op.NODECE = form.getFieldValue("NODECE");
      // op.UTISAI = form.getFieldValue("UTISAI");
      // op.CODAGE = form.getFieldValue("CODAGE");
      // op.NUMSEQ = form.getFieldValue("NUMRAP");

      const response = await axios.get(`${apiEndpoints.fastReport}/PrintRecuCaisse`, {
        params: {
          CodAgce, Libelle, Nodece, NumSeq, UtiSai, NomUser, SensOpe, LibDevise, LibInfos
        },
        responseType: 'blob',
      });

      if (response.data) {
        // alert( response.data);
        const blob = new Blob([response.data], { type: "application/pdf" });
        const now = new Date();
        const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
        const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
        const fileName = `PrintRecuCaisse_${NumSeq}_${UtiSai}_${formattedDate}_${formattedTime}.${format}`;

        //const fileName = `PrintRecuCaisse_${NumSeq}_${UtiSai}_${new Date().toLocaleTimeString("fr-FR").replace(/\//g, "-")}.${format}`;
        // const url = window.URL.createObjectURL(blob);
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", fileName);
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // window.URL.revokeObjectURL(url);

        //       const file = new File([blob], fileName, { type: "application/pdf" });
        //       const url = URL.createObjectURL(file);
        //       const previewHtml = `
        //   <html>
        //     <head>
        //       <title>${fileName}</title>
        //     </head>
        //     <body style="margin:0">
        //       <iframe src="${url}" width="100%" height="100%" style="border:none;"></iframe>
        //     </body>
        //   </html>
        // `;

        // const previewBlob = new Blob([previewHtml], { type: "text/html" });
        // const previewUrl = URL.createObjectURL(previewBlob);
        // window.open(previewUrl, '_blank');
        //window.open(url, '_blank');

        //const url = window.URL.createObjectURL(blob);
        //window.open(url, '_blank'); // Ouvre le PDF dans un nouvel onglet pour prévisualisation
        const url = window.URL.createObjectURL(blob);
        //       SweetAlert.fire({
        //   title: "Reçu généré",
        //   text: "Souhaitez-vous prévisualiser ou télécharger le reçu ?",
        //   icon: "question",
        //   showCancelButton: true,
        //   confirmButtonText: "Prévisualiser",
        //   cancelButtonText: "Télécharger"
        // }).then((result) => {

        //   if (result.isConfirmed) {
        //     window.open(url, '_blank'); // Prévisualisation
        //   } else {
        //     const link = document.createElement("a");
        //     link.href = url;
        //     link.setAttribute("download", fileName);
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //     window.URL.revokeObjectURL(url);

        //   }
        // });

        //   setTimeout(() => {
        //       window.URL.revokeObjectURL(url);
        //       }, 10000);     

        SweetAlert.fire({
          title: "Reçu généré",
          text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
          icon: "question",
          showCancelButton: true,
          showDenyButton: true,
          denyButtonText: "Imprimer",
          confirmButtonText: "Prévisualiser",
          cancelButtonText: "Télécharger"
        }).then((result) => {
          const file = new File([blob], fileName, { type: "application/pdf" });
          const url = URL.createObjectURL(file);

          if (result.isConfirmed) {
            // ✅ Prévisualiser
            window.open(url, '_blank');
          } else if (result.isDenied) {
            // ✅ Imprimer directement via iframe
            const printHtml = `
       <html>
         <head>
           <title>${fileName}</title>
           <style>
             html, body {
               margin: 0;
               height: 100%;
             }
             iframe {
               width: 100%;
               height: 100%;
               border: none;
             }
           </style>
         </head>
         <body>
           <iframe id="pdfFrame" src="${url}"></iframe>
           <script>
             const iframe = document.getElementById('pdfFrame');
             iframe.onload = function() {
               setTimeout(() => {
                 iframe.contentWindow.focus();
                 iframe.contentWindow.print();
               }, 500);
             };
           </script>
         </body>
       </html>
     `;
            const printBlob = new Blob([printHtml], { type: "text/html" });
            const printUrl = URL.createObjectURL(printBlob);
            window.open(printUrl, '_blank');
          } else {
            // ✅ Télécharger
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          // Nettoyage après quelques secondes
          setTimeout(() => {
            URL.revokeObjectURL(url);
          }, 10000);
        });

      } else {
        SweetAlert.fire({ title: "Erreur", text: String("Erreur lors du téléchargement du fichier :"), icon: "error" });
      }

      // setLoading(false);

    } catch (error) {
      // setLoading(false);
      console.error("Erreur lors du téléchargement du fichier :", error);
      SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
    }
  };


  function transfert(data: any) {
    var newDatas = {
      montantOpe: data.MONTAN,
    }
    try {
      setLoading(true);
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetUserAbleToValidateLitige,
        headers: {
          "CypherOeration": Crypter.encrypt(JSON.stringify(newDatas)),
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
        data: Crypter.encrypt(JSON.stringify(newDatas)),
      };

      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              transfertLitige(data, res.Result.Table)
            }
            else {
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
        })

    } catch (error) {
      SweetAlert.fire({ title: JSON.stringify(error), icon: "error" })
    }
  }

  function transfertLitige(data: any, userVal: any) {
    var UsersVal: { [name: string]: string } = {};

    userVal.map((u: any) => {
      UsersVal[u.CODUTI] = u.CODUTI + " - " + u.NOMUTI
    })
    SweetAlert.fire({
      title: "Tranfert d'opération litigieuse",
      text: "Veillez selectionner l'utilisateur qui vas valider l'opération",
      showCancelButton: true,
      color: "green",
      confirmButtonText: "Yes",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      input: 'select',
      inputOptions: UsersVal,
      inputPlaceholder: "Utilisateur qui dois valider l'opération",
      icon: 'question'
    }).then((resp) => {

      if (resp.isConfirmed) {
        if (resp.value != null && resp.value != "") {

          var newDatas = {
            NUMCPT: data.NODUCP,
            CODAGE: data.AEDUCP,
            UTISAI: user.coduti,
            NLINE: data.NLINE,
            utiVal: resp.value
          }
          try {
            setLoading(true);
            let config = {
              method: 'put',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.TransfertOperationLitigieuse,
              headers: {
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: Crypter.encrypt(JSON.stringify(newDatas)),
            };

            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                  if (res.StatutCode == 200) {
                    LoadLitige()
                    SweetAlert.fire({ title: res.Message, icon: "success" })
                    localStorage.setItem(Data.LocalVariable.reset, "1")

                  }
                  else {
                    SweetAlert.fire({ title: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: error, icon: "error" })
              })

          } catch (error) {
            SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
          }
        } else {
          SweetAlert.fire({ title: "Veillez sélectionner l'utilisateur qui doit valider l'opération", icon: "warning" })
        }
      }
    })
  }

  function regetLitige(data: any) {
    var newDatas = {
      NUMCPT: data.NODUCP,
      lib_CODOPE: data.LIBELL,
      CODAGE: data.AEDUCP,
      DateOpe: data.DATECR,
      nomClient: data.REMETT,
      DateVal: data.DEDEVR,
      montantOpe: data.MONTAN,
      CDDEVS: data.CDDEVS,
      refOpe: data.NUMRAP,
      CODOPE: data.CDLBEC,
      // NOMB01: props.form.getFieldValue("NOMB01"),
      // NOMB02: props.form.getFieldValue("NOMB02"),
      // NOMB03: props.form.getFieldValue("NOMB03"),
      // NOMB04: props.form.getFieldValue("NOMB04"),
      // NOMB05: props.form.getFieldValue("NOMB05"),
      // NOMB06: props.form.getFieldValue("NOMB06"),
      // NOMB07: props.form.getFieldValue("NOMB07"),
      // NOMB08: props.form.getFieldValue("NOMB08"),
      // NOMB09: props.form.getFieldValue("NOMB09"),
      // NOMB10: props.form.getFieldValue("NOMB10"),
      // NOMB11: props.form.getFieldValue("NOMB11"),
      // NOMB12: props.form.getFieldValue("NOMB12"),
      // NOMB13: props.form.getFieldValue("NOMB13"),
      Taxe: data.TAUX,
      CNIClient: data.cniremet,
      LieuDeliv: data.lieudelrem,
      DateDeliv: data.datdelrem,
      TypeOpe: data.sensec,
      UTISAI: data.codUti,
      NLINE: data.NLINE
    }
    //alert(JSON.stringify(data))
    SweetAlert.fire({
      title: "Voulez-vous rejetter cette opération litigieuse?",
      showCancelButton: true,
      color: "green",
      confirmButtonText: "Yes",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'question'
    }).then((res) => {
      if (res.isConfirmed) {

        try {
          setLoading(true);
          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.RegetOperationLitigieuse,
            headers: {
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: Crypter.encrypt(JSON.stringify(newDatas)),
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                if (res.StatutCode == 200) {
                  LoadLitige()
                  SweetAlert.fire({ title: res.Message, icon: "success" })
                  localStorage.setItem(Data.LocalVariable.reset, "1")

                }
                else {
                  SweetAlert.fire({ title: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            })

        } catch (error) {
          SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
        }
      }
    })
  }

  function ConfirmLitige(data: any) {
    //alert(JSON.stringify(data.CDLBEC))
    if (data.MONTAN == ReformatNumber(props.form.getFieldValue("TotalBilletage"))) {
      var newDatas: any = {
        NUMCPT: data.NODUCP,
        lib_CODOPE: data.LIBELL,
        CODAGE: data.AEDUCP,
        DateOpe: data.DATECR,
        nomClient: data.REMETT,
        DateVal: data.DEDEVR,
        montantOpe: data.MONTAN,
        CDDEVS: data.CDDEVS,
        refOpe: data.NUMRAP,
        CODOPE: data.CDLBEC,
        // NOMB01: props.form.getFieldValue("NOMB01"),
        // NOMB02: props.form.getFieldValue("NOMB02"),
        // NOMB03: props.form.getFieldValue("NOMB03"),
        // NOMB04: props.form.getFieldValue("NOMB04"),
        // NOMB05: props.form.getFieldValue("NOMB05"),
        // NOMB06: props.form.getFieldValue("NOMB06"),
        // NOMB07: props.form.getFieldValue("NOMB07"),
        // NOMB08: props.form.getFieldValue("NOMB08"),
        // NOMB09: props.form.getFieldValue("NOMB09"),
        // NOMB10: props.form.getFieldValue("NOMB10"),
        // NOMB11: props.form.getFieldValue("NOMB11"),
        // NOMB12: props.form.getFieldValue("NOMB12"),
        // NOMB13: props.form.getFieldValue("NOMB13"),
        Taxe: data.TAUX,
        CNIClient: data.cniremet,
        LieuDeliv: data.lieudelrem,
        DateDeliv: data.datdelrem,
        TypeOpe: (data.CDLBEC == '950' || data.CDLBEC == '052') ? "VER" : (data.CDLBEC == '951' || data.CDLBEC == '051') ? "RET" : (data.CDLBEC == '955') ? "ENV" : "REC",
        UTISAI: data.UTISAI,
        NLINE: data.NLINE,

        AUTORI: data.AUTORI,
        BLOQUE: data.BLOQUE,
        CAIUTI: user.nomuti,
        //NODECE: data.NODECE,
        NODECE: props.form.getFieldValue("NODECE"),
        lib_CDDEVS: "FRANC CFA BEAC",
        TelBenef: data.teleph,
        utiVal: data.UTIVAL,
        CODOPE1: data.CDLBEC,
        AGCEDEPART: user.codage,

        NUMCHQ: data.NUMCHQ,
        SERCHQ: data.SERCHQ,
        //NODECE: data.NODECE,
        NUMSEQ: data.NUMRAP,
        // UTISAI: data.coduti,
        Billetages: props.form.getFieldValue("Billetages")
      }
      //alert(newDatas.typeOpe)
      SweetAlert.fire({
        title: "Voulez-vous confirmer cette opération litigieuse?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {

          try {
            setLoading(true);
            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.ConfirmOperationLitigieuse,
              headers: {
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: Crypter.encrypt(JSON.stringify(newDatas)),
            };

            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                  if (res.StatutCode == 200) {
                    // alert(newDatas.NODECE)

                    LoadLitige()
                    SweetAlert.fire({ title: res.Message, icon: "success" })
                    localStorage.setItem(Data.LocalVariable.reset, "1")

                    //Impression Recu
                    newDatas.NUMSEQ = res.Message.split(" : ")[1]
                    let data = { "form": newDatas }
                    localStorage.setItem(Data.LocalVariable.Recu, JSON.stringify(data))
                    // navigate("/operation/Deposit&withdrawal/print")
                    // navigate("/caisse/veresmentretrait/print")


                    // handleDownloadRecuDirect(newDatas.NODECE,newDatas.NUMSEQ,newDatas.UTISAI,newDatas.lib_CODOPE,newDatas.CDDEVS,newDatas.lib_CDDEVS,newDatas.CODOPE1,newDatas.NUMCPT,Number(newDatas.montantOpe),newDatas.CDDEVS,"pdf")  
                    PrintRecuCaisseDirect(user.codage, user.agence, user.nomuti, newDatas.NODECE, newDatas.NUMSEQ, newDatas.UTISAI, newDatas.lib_CODOPE, "XAF", "FRANC CFA BEAC", newDatas.CODOPE1, newDatas.NUMCPT, Number(newDatas.montantOpe), "pdf")
                  }
                  else {
                    SweetAlert.fire({ title: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: error, icon: "error" })
              })

          } catch (error) {
            SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
          }
        }
      })
    } else {
      SweetAlert.fire({ title: 'Votre Bielletage est incorrect', icon: "warning" })
    }
  }

  function LoadLitige() {

    let search: Params = { CodeAgence: user.codage, Table: "LITIGE", Colonne1: "UTISAI", Colonne2: "", Colagence: '101', Init: user.coduti, Choix: 35 }

    setLoading(true)
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          console.log(res)

          if (res.StatutCode == 200) {
            // alert(res.Message)
            var datat: any[] = [];
            res.Result.Table.map((r: any, indice: number) => {
              // alert(res.Result.Table.length)
              if (r.CDETAT != 16 && r.CDETAT != '06') {

                r.LIBOPE = r.LIBOPE.split('|')[1]
                datat.push({
                  key: indice,
                  ...r
                });
              }
              setDonnee(datat);
            }
            )
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }

  function searchOpe(value: string) {

    let search: Params = { CodeAgence: '', Table: "LITIGE", Colonne1: "NUMRAP", Colonne2: "", Colagence: '101', Init: value, Choix: 35 }
    setLoading(true)
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          //alert(JSON.stringify(res))
          if (res.StatutCode == 200) {
            //setDonnee(res.Result.Table)

            var datat: any[] = [];
            res.Result.Table.map((r: any, indice: number) => {
              //console.log(JSON.stringify(data))
              datat.push({
                key: indice,
                NUMRAP: r.NUMRAP,
                NODUCP: r.NODUCP,
                LIBELL: r.LIBELL,
                DATECR: r.DATECR,
                REMETT: r.REMETT,
                cniremet: r.cniremet,
                MONTAN: r.MONTAN,
                MOTIF: r.MOTIF,
                LIBOPE: r.LIBOPE,
                soldeApreOpe: r.soldeApreOpe,
              });
              setDonnee(datat);
            }
            )
          }
          else {
            SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }
  const onSelectChange = (newSelectedRowKeys: any) => {
    let r = Donnee[newSelectedRowKeys]
    var newDatas = {
      NUMCPT: r.NODUCP,
      lib_CODOPE: r.LIBELL,
      CODAGE: r.AEDUCP,
      DateOpe: r.DATECR,
      nomClient: r.REMETT,
      DateVal: r.DEDEVR,
      montantOpe: r.MONTAN,
      CDDEVS: r.CDDEVS,
      refOpe: r.NUMRAP,
      CODOPE: r.CDLBEC,
      // NOMB01: r.NOMB01,
      // NOMB02: r.NOMB02,
      // NOMB03: r.NOMB03,
      // NOMB04: r.NOMB04,
      // NOMB05: r.NOMB05,
      // NOMB06: r.NOMB06,
      // NOMB07: r.NOMB07,
      // NOMB08: r.NOMB08,
      // NOMB09: r.NOMB09,
      // NOMB10: r.NOMB10,
      // NOMB11: r.NOMB11,
      // NOMB12: r.NOMB12,
      // NOMB13: r.NOMB13,
      Taxe: r.TAUX,
      CNIClient: r.cniremet,
      LieuDeliv: r.lieudelrem,
      DateDeliv: r.datdelrem,
      TypeOpe: r.sensec,
      UTISAI: r.codUti,
    }
    //props.form.setFieldsValue(newDatas)
    // SweetAlert.fire({
    //   title: "Confirmation Litige\n\n" + ((newDatas.TypeOpe == 'VER') ? "VERSEMENT" : (newDatas.TypeOpe == 'RET') ? "RETRAIT" : (newDatas.TypeOpe == 'ENV') ? "ENVOI D'ARGENT" : "RECEPTION D'ARGENT ") + " " + " de " + formatNumber(parseInt(newDatas.montantOpe)) + " XAF\nPar " + newDatas.nomClient + "\nCompte : \n" + newDatas.NUMCPT,
    //   showDenyButton: true,
    //   showCancelButton: true,
    //   confirmButtonText: 'Valider',
    //   denyButtonText: 'Regété',
    //   showCloseButton: true,
    //   customClass: {
    //     actions: 'my-actions',
    //     cancelButton: 'order-1 right-gap',
    //     confirmButton: 'order-2',
    //     denyButton: 'order-3',
    //   }
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     SweetAlert.fire('Saved!', '', 'success')
    //   } else if (result.isDenied) {
    //     SweetAlert.fire('Changes are not saved', '', 'info')
    //   }
    //   setSelectedRowKeys([]);
    // })
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // setTimeout(() => {
  //   try {
  //     let reset = localStorage.getItem(Data.LocalVariable.resetTable)
  //     if (reset == "1") {
  //       setSelectedRowKeys([])
  //       localStorage.removeItem(Data.LocalVariable.resetTable)
  //     }
  //   }
  //   catch (error) { }
  // }, .1);



  return (

    <Spin spinning={loading} size='large' style={{ color: 'green' }} >
      <div className='tabItem'>
        <div>

          <Box fontStyle="inherit">
            <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
              <legend>Opération en attente de confirmation</legend>
              <Box display={"flex"} fontStyle={"inherit"}>
                <hr />
                <Input.Search onSearch={(v: string) => { searchOpe(v) }} required={false} placeholder="Entrez la reférence de l'opération" name='search' type={'search'} /><br /><br />
              </Box>

              <Box fontStyle="inherit" className='bordure1'>
                <Button onClick={LoadLitige} variant='contained' size='small' className='bt_add' >Actualiser</Button><br /><br />

                <Table size='small' columns={columns} /*rowSelection={{ ...rowSelection, type: "radio", }}*/ pagination={{ pageSize: 5, position: ["bottomRight"] }} dataSource={Donnee} />

              </Box>

            </Box>
          </Box>
        </div>
      </div>
    </Spin>
  );
}

export default Tab2;